export default {
  props: {
    variant: {
      type: String,
      default: null
    }
  },

  methods: {
    getVariant(className) {
      if (!this.variant) {
        return '';
      }

      const variant = this.variant.split(' ');
      return variant.map((value) => `${className}--${value}`);
    }
  }
};



// WEBPACK FOOTER //
// src/mixins/variant.js